import React from "react";

import { getDamPath } from "@utils/configuration/aem";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import CalculationField from "@components/Calculator/CalculationField/calculationField.component";
import { Col } from "@components/General/Grid/col.component";
import { Row } from "@components/General/Grid/row.component";

type Props = {
    setCalculationValue: any;
    wallLength: number;
    wallHeight: number;
    glassBrickLength: number;
    glassBrickWidth: number;
    glassBrickHeight: number;
};

const Calculation = ({
    setCalculationValue,
    wallLength,
    wallHeight,
    glassBrickLength,
    glassBrickWidth,
    glassBrickHeight,
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col className={"col-xs-12 col-md-8"}>
                    <h3 className="d-sm-block">
                        {t("calculator.brickCalculator.measurementWall")}
                    </h3>
                    <Row>
                        <CalculationField
                            name={"wallLength"}
                            dimension={"length"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            {...(wallLength && { value: wallLength })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                        <CalculationField
                            name={"wallHeight"}
                            dimension={"height"}
                            unit={"m"}
                            setCalculationValue={setCalculationValue}
                            {...(wallHeight && { value: wallHeight })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                    </Row>
                    <h3 className="d-sm-block">
                        {t("calculator.glassbrickCalculator.measurementBricks")}
                    </h3>
                    <Row>
                        <CalculationField
                            name={"glassBrickLength"}
                            dimension={"length"}
                            unit={"cm"}
                            setCalculationValue={setCalculationValue}
                            {...(glassBrickLength && {
                                value: glassBrickLength,
                            })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                        <CalculationField
                            name={"glassBrickWidth"}
                            dimension={"width"}
                            unit={"cm"}
                            setCalculationValue={setCalculationValue}
                            {...(glassBrickWidth && { value: glassBrickWidth })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                        <CalculationField
                            name={"glassBrickHeight"}
                            dimension={"height"}
                            unit={"cm"}
                            setCalculationValue={setCalculationValue}
                            {...(glassBrickHeight && {
                                value: glassBrickHeight,
                            })}
                            sm={8}
                            md={6}
                            lg={4}
                        />
                    </Row>
                </Col>
                <Col className={"col-md-4 d-flex text-center align-items-end"}>
                    <img
                        className={"mt-3 calculator-image"}
                        src={`${getDamPath()}/hulp-en-advies/calculators/glasdal.jpg`}
                        alt={"glasdal.jpg"}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default Calculation;
